import { ApiService } from '@angular/synthrone-design/services/api/api.service';
import { Component, Injectable, Inject, OnInit } from '@angular/core';
import { CommonFunctionsService } from '@angular/synthrone-design/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'scenarios-monitoring-view',
  templateUrl: './scenarios-monitoring-view.component.html',
  styleUrls: ['./scenarios-monitoring-view.component.scss']
})

export class ScenariosMonitoringViewComponent implements OnInit {

  platforms = [];
  loadedData = false;
  platfomrsTimer;

  sortTypes;
  currentSort;
  lastUpdate;
  refreshEvery = 15;//minutes
  minPercents = 0;
  maxPercents = 100;
  clockSize = 80;
  filterSlug = "";
  auditsTypes = ["direct", "search", "category"];

  constructor(@Inject(CommonFunctionsService) public commonFunctions, protected api: ApiService) {
    this.sortTypes = [
      {
        key: 'platform_slug',
        label: 'platform',
        sortFn: function (o){
          return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
        }
      },
      {
        key: 'percents',
        label: 'success rate',
        sortFn: function (o){
          return Object.keys(o).sort((a, b) => o[a]-o[b]).reduce((_sortedObj, key) => ({..._sortedObj, [key]: o[key]}), {})
        }
      },
    ];

    this.currentSort = this.sortTypes[0];
  }

  ngOnInit(){
    this.getPlatforms();
  }

  refresh = () => {
    this.loadedData = false;
    this.getPlatforms();
  }

  setSort = (sort) => {
    this.currentSort = sort;
    this.sortPlatforms();
  }

  getPlatforms = () => {
    if(this.platfomrsTimer){
      clearTimeout(this.platfomrsTimer);
    }
    return this.api.makeRequest('api_system_projects_success_rate', {
      _salt: (new Date()).getTime()
    }, 'explorer').subscribe(results => {
      this.lastUpdate = new Date();
      this.loadedData = true;
      this.platforms = this.setPlatforms(<any>results);
      this.sortPlatforms();
      this.platfomrsTimer = setTimeout(() => {
        this.getPlatforms();
      }, 1000 * 60 * this.refreshEvery);
    });
  }

  setPlatforms = (platforms) => {
    var platformsTemp:any = {
      "direct":{},
      "search":{},
      "category":{}
    };
    Object.keys(platforms).forEach((platform) => {
      platformsTemp.direct[platforms[platform]['platform_slug']] = platforms[platform].percentsDirect;
      platformsTemp.search[platforms[platform]['platform_slug']] = platforms[platform].percentsSearch;
      platformsTemp.category[platforms[platform]['platform_slug']] = platforms[platform].percentsCategory;
    })
    return platformsTemp;
  }

  sortPlatforms = () => {
    this.platforms['direct'] = this.currentSort.sortFn(this.platforms['direct'])
    this.platforms['search'] = this.currentSort.sortFn(this.platforms['search'])
    this.platforms['category'] = this.currentSort.sortFn(this.platforms['category'])
  }

  setRefresh = (minutes) => {
    this.refreshEvery = minutes;
    this.getPlatforms();
  }

  slugFilter = (slug:string) => {
    const slugFilter:string = this.filterSlug.trim();
    return slugFilter == "" || slug.trim().indexOf(slugFilter) > -1;
  }

  isEmpty = (type) => {
    let isEmpty = true;
    Object.keys(this.platforms[type]).forEach((platform) => {
      if (this.platforms[type][platform] >= this.minPercents && this.platforms[type][platform] <= this.maxPercents && this.slugFilter(platform) && this.platforms[type][platform]) {
        isEmpty = false;
      }
    });
    return isEmpty;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/scenarios-monitoring-view/scenarios-monitoring-view.component.ts